import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MARKETS_URL, SIGNUP_URL, ORIGINAL_MARKETS_URL } from "./links";

export default function Header() {
  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <a
          data-testid="header-brand-link"
          href={ORIGINAL_MARKETS_URL}
          aria-label="Aureon Global Markets"
          className="group flex items-center"
        >
          <span className="flex items-center gap-1.5 rounded-full border border-gold/40 px-3.5 py-1.5 text-[10px] uppercase tracking-[0.2em] text-gold/80 transition-colors duration-300 group-hover:bg-gold group-hover:text-ink">
            Visit
            <ArrowUpRight className="h-3 w-3 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </span>
        </a>
        <nav className="flex items-center gap-6">
          <a
            data-testid="header-live-markets-link"
            href={ORIGINAL_MARKETS_URL}
            className="group hidden items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-white/60 transition-colors duration-300 hover:text-gold sm:flex"
          >
            Live markets
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <a
            data-testid="header-access-link"
            href="#access"
            className="hidden text-xs uppercase tracking-[0.2em] text-white/60 transition-colors duration-300 hover:text-gold sm:inline"
          >
            Get access
          </a>
          <a
            data-testid="header-signin-link"
            href={MARKETS_URL}
            className="hidden text-xs uppercase tracking-[0.2em] text-white/60 transition-colors duration-300 hover:text-gold sm:inline"
          >
            Sign in
          </a>
          <a
            data-testid="header-create-account-btn"
            href={SIGNUP_URL}
            className="group flex items-center gap-2 rounded-full border border-gold/40 px-5 py-2 text-xs uppercase tracking-[0.2em] text-gold transition-colors duration-300 hover:bg-gold hover:text-ink"
          >
            Create account
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </nav>
      </div>
    </motion.header>
  );
}
